import {Pipe, PipeTransform} from '@angular/core';
import {customerColor, customerInk, customerTint} from './customer-color';

/**
 * `companyId | customerColor` gives the customer color (dots, blocks), `companyId | customerColor:'ink'`
 * a readable text color and `companyId | customerColor:'tint'` the light background for tags.
 * Impure, because the colors are loaded after the first render.
 */
@Pipe({
    name: 'customerColor',
    pure: false
})
export class CustomerColorPipe implements PipeTransform {
    transform(companyId: number | string | null | undefined, variant: 'color' | 'ink' | 'tint' = 'color'): string {
        switch (variant) {
            case 'ink':
                return customerInk(companyId);
            case 'tint':
                return customerTint(companyId);
            default:
                return customerColor(companyId);
        }
    }
}
